import { createDynamicSlice } from ".";
import { fetchRolesThunk } from "../thunks/rolesThunk";

export const rolesSlice = createDynamicSlice({
  name: "roles",
  thunk: fetchRolesThunk,
  listMode: true,
  resetActionName: "resetRoles",
});

export const rolesReducer = rolesSlice.reducer;
export const { resetRoles } = rolesSlice.actions;
